
<div class="sidebar-panel-head" *ngIf="metadata">
  <div class="sidebar-title-group">
    <div class="sidebar-title">{{ metadata.name || 'Content' }}</div>
    <div class="sidebar-meta">{{ metadata.type || 'training' }}</div>
  </div>
  <button class="icon-button properties-popover-trigger" type="button"
    (click)="metadataPropertiesOpen.emit($event)" popovertarget="properties-popover" title="Edit properties">
    <i class="fa fa-pencil-square-o"></i>
  </button>
</div>

<div class="sidebar-search">
  <input type="text" placeholder="Load content..." [ngModel]="contentSearchTerm"
    (ngModelChange)="onContentSearch($event)" (focus)="showContentDropdown = true">
  <div class="toggle-row">
    <div class="source-actions">
      <button type="button" class="import-source-btn" (click)="copySourceJsonClick.emit()">
        <i class="fa" [ngClass]="{'fa-clone': copySourceJsonState !== 'success', 'fa-check': copySourceJsonState === 'success'}"></i>
        <span>{{ copySourceJsonState === 'success' ? 'Copied!' : 'Copy source' }}</span>
      </button>

      <button type="button" class="import-source-btn" (click)="importSourceClick.emit()">
        <i class="fa fa-upload"></i>
        <span>Import source</span>
      </button>
    </div>

    <div class="template-toggle">
      <span>Templates</span>
      <label class="switch">
        <input type="checkbox" [checked]="isTemplateMode" (change)="templateModeToggled.emit()">
        <span class="slider round"></span>
      </label>
    </div>
  </div>
  @if (showContentDropdown && contentSearchResults.length > 0) {
  <div class="dropdown-results">
    @for (item of contentSearchResults; track $index) {
    <div class="result-item" (click)="selectContent(item)">{{ item.name.replaceAll('"','') }}</div>
    }
  </div>
  }
</div>


<div class="sidebar-panel">
  <div class="sidebar-tree" [class.dual-pane]="isDualPane">
    @if (isDualPane) {
    <app-tree [items]="sourceRoutes" [level]="0" [treeType]="'source'" [isEditingEnabled]="false"
      [isReorderEnabled]="true" [isDualPane]="true" [routeTransferMode]="true"></app-tree>
    } @else {
    <app-tree [items]="sourceRoutes" [level]="0" [treeType]="'source'" [isEditingEnabled]="false"
      [isReorderEnabled]="true" [isDualPane]="false" [sidebarReorderMode]="true"
      [selectedItemId]="selectedSourceComponentId"
      (orderChanged)="orderChanged.emit()" (itemClicked)="sidebarItemClicked.emit($event)"></app-tree>
    }
  </div>
</div>
